import { useQuery } from 'convex/react'
import { api } from '@backend/_generated/api'
import { useConvexAuth } from 'convex/react'

/**
 * Returns the current user's Convex `_id` as a string.
 *
 * Used wherever we need to compare a user ID against Convex document fields
 * (e.g. assessment responses). Safe to use in place of the legacy
 * `useCurrentUserId()` for Convex-backed features.
 */
export function useMyConvexUserId(): string | undefined {
  const { isAuthenticated } = useConvexAuth()
  const profile = useQuery(
    api.profile.getMyProfile,
    isAuthenticated ? {} : 'skip',
  )
  return profile?.userId ?? undefined
}
